import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-video",
  "use": "foquz-icon-video-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" id=\"foquz-icon-video\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 20a4 4 0 004 4h16a4 4 0 004-4V4a4 4 0 00-4-4H4a4 4 0 00-4 4v16zm20 2H4a2 2 0 01-2-2V4a2 2 0 012-2h16a2 2 0 012 2v16a2 2 0 01-2 2zM10 9v5.764l5.764-2.882L10 9zm-1.789 6.658a2 2 0 002.683.895l5.764-2.882a2 2 0 000-3.578l-5.764-2.882A2 2 0 008 9v5.764a2 2 0 00.211.894z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol